var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.64869314,0,0,0.64869314,-102.6008,-143.77535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 890.55,833.325 c 0.067,62.503 -51.957,112.874 -115.089,110.075 -12.986,-0.573 -25.433,-3.452 -36.924,-8.219 -29.885,-12.424 -61.694,-19.575 -94.053,-19.541 h -8.714 c -33.326,0.034 -66.27,6.791 -97.01,19.665 -14.527,6.083 -30.65,9.141 -47.572,8.388 -56.409,-2.519 -102.249,-48.269 -104.891,-104.667 -1.732,-37.194 14.988,-70.576 41.804,-91.759 38.532,-30.414 65.449,-73.241 78.154,-120.666 14.729,-55.094 49.742,-113.178 131.786,-113.257 81.179,-0.09 116.326,58.186 131.415,113.347 13.054,47.808 41.399,89.881 79.998,120.947 25.04,20.148 41.062,51.034 41.096,85.687 z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 454.985,591.587 c 0.056,56.375 -37.531,102.114 -83.967,102.159 -46.425,0.045 -84.102,-45.615 -84.158,-101.991 -0.056,-56.375 37.531,-102.114 83.956,-102.159 46.424,-0.044 84.112,45.616 84.169,101.991 z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 612.867,369.257 c 0.056,56.375 -37.531,102.114 -83.956,102.159 -46.425,0.056 -84.102,-45.615 -84.169,-101.991 -0.056,-56.364 37.531,-102.114 83.967,-102.159 46.425,-0.045 84.102,45.615 84.158,101.991 z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 989.381,591.036 c 0.056,56.375 -37.531,102.114 -83.956,102.159 -46.436,0.056 -84.113,-45.615 -84.169,-101.979 -0.056,-56.375 37.531,-102.126 83.956,-102.171 46.425,-0.044 84.113,45.616 84.169,101.991 z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 831.038,369.032 c 0.056,56.375 -37.531,102.114 -83.967,102.171 -46.425,0.045 -84.102,-45.615 -84.158,-101.991 -0.056,-56.376 37.531,-102.114 83.956,-102.171 46.424,-0.045 84.113,45.615 84.169,101.991 z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.dff1f870262b8151c79f549d42fd6c10.svg";
export { ForwardRef as ReactComponent };